import { Stepper, Step } from 'react-form-stepper';
import { IoHammerOutline, IoSearch } from 'react-icons/io5';
import { BsBoxSeam } from 'react-icons/bs';
import { FaCalendarDays } from 'react-icons/fa6';
import { LuPartyPopper } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';
import { PROJECT_STATUS } from '@/lib/constants';
import { CheckIcon } from 'lucide-react';

type FormStepperProps = {
  currentStatus: string;
};

export const ProjectHeader = ({ currentStatus }: FormStepperProps) => {
  const currentStep =
    PROJECT_STATUS.indexOf(currentStatus) !== -1
      ? PROJECT_STATUS.indexOf(currentStatus)
      : 0;

  console.log(currentStep);

  const isStepCompleted = (index: number) => {
    return index < currentStep;
  };
  const { t } = useTranslation();
  //#0087E5
  return (
    <div className="">
      <Stepper
        className="px-0"
        activeStep={currentStep}
        connectorStyleConfig={{
          size: 12,
          disabledColor: '#0087E5',
          activeColor: '#ed1d24',
          completedColor: '#a10308',
          style: 'solid',
        }}
        styleConfig={{
          activeBgColor: '#e53d51',
          activeTextColor: '#ffffff',
          completedBgColor: '#e53d51',
          completedTextColor: '#ffffff',
          inactiveBgColor: '#3FA2F6',
          inactiveTextColor: '#ffffff',
          size: '1.5rem',
          circleFontSize: '1rem',
          labelFontSize: '0.875rem',
          borderRadius: '50%',
          fontWeight: 500,
        }}
      >
        {PROJECT_STATUS.map((label, index) => {
          const isStepComplete = isStepCompleted(index);
          const size = 'w-10 h-10 md:w-12 md:h-12 ';
          const status = label.toLowerCase().replace(/\s/g, '');
          const translation = t(status);
          const isCurrentStep = currentStatus === label;
          return (
            <Step
              key={index}
              //@ts-expect-error The label not supposed to receive a div
              label={
                <span
                  className={`mb-4 block ${isStepComplete ? 'font-medium' : 'font-bold'} text-xs ${isCurrentStep ? 'text-primary font-bold' : ''}`}
                >
                  {translation}
                </span>
              }
            >
              <div
                className={`${size} rounded-full ${isStepComplete || isCurrentStep ? 'bg-primary' : 'bg-blue-500'} flex items-center justify-center relative z-10 mx-auto border-4 md:border-white`}
              >
                {isStepComplete ? (
                  <CheckIcon className="w-4 h-4 md:h-6 md:w-6" />
                ) : (
                  <>
                    {label === 'Awaiting Inspection' && (
                      <IoSearch className="w-4 h-4 md:h-6 md:w-6" />
                    )}
                    {label === 'Materials Ordered' && (
                      <BsBoxSeam className="w-4 h-4 md:h-6 md:w-6" />
                    )}
                    {label === 'Awaiting Install' && (
                      <FaCalendarDays className="w-4 h-4 md:h-6 md:w-6" />
                    )}
                    {label === 'Day of Install' && (
                      <IoHammerOutline className="w-4 h-4 md:h-6 md:w-6" />
                    )}
                    {label === 'Project Complete' && (
                      <LuPartyPopper className="w-4 h-4 md:h-6 md:w-8" />
                    )}
                  </>
                )}
              </div>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};
